<template>
  <div
    v-if="value.Author"
    class="flex">
    <UserIcon
      v-if="value.AuthorType === 'User'"
      :name="value.Author"
      size="32"/>
    <UserIcon
      v-else
      class="avatar"
      size="32">
      <sIcon
        color="var(--white-color)"
        :type="value.AuthorType === 'Robot' ? 'tag-auto' : 'reminder'"/>
    </UserIcon>
    <TooltipedText
      ref="TooltipedText"
      class="notification-org-title"
      :max-length="mode==='modal' ? 50 : 19"
      :value="value.Author"/>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

export default {
  name: 'notificationCardAuthor',
  props: {
    value: {
      type: Object
    },
    mode: {
      type: String,
      default: 'card'
    }
  },
  components: {
    UserIcon,
    TooltipedText
  }
}
</script>
<style scoped lang="scss">
.notification-org-title {
  text-align: left;
  font-weight: 500;
  font-size: 0.75rem;
  margin: auto 0 auto 5px;
}
</style>
